import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MediaService } from '../../../services/media.service';
@Component({
  selector: 'app-photo-uploader',
  templateUrl: './photo-uploader.component.html',
  styleUrls: ['./photo-uploader.component.css']
})
export class PhotoUploaderComponent {

  @Input() value: string | undefined | null = '';
  @Input() label = 'Photo';
  @Output() valueChange = new EventEmitter<string>();

  enCours = false;
  erreur = '';

  constructor(private mediaService: MediaService) { }

  onUrlModifiee(nouvelleValeur: string): void {
    this.value = nouvelleValeur;
    this.valueChange.emit(this.value);
  }

  onFichierSelectionne(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    this.erreur = '';
    this.enCours = true;

    this.mediaService.uploadImage(input.files[0]).subscribe({
      next: (reponse) => {
        this.enCours = false;
        if (reponse.success) {
          this.value = reponse.url;
          this.valueChange.emit(this.value);
        } else {
          this.erreur = reponse.message || "Erreur lors de l'import.";
        }
      },
      error: () => {
        this.enCours = false;
        this.erreur = 'Impossible de contacter le serveur.';
      }
    });

    input.value = '';
  }

  // Determine si l'URL/valeur actuelle pointe vers une video (extension) pour choisir
  // entre <video> et <img> dans l'apercu
  estVideo(valeur: string | undefined | null): boolean {
    if (!valeur) return false;
    return /\.(mp4|webm|mov|avi)(\?.*)?$/i.test(valeur);
  }

  effacer(): void {
    this.value = '';
    this.valueChange.emit(this.value);
  }
}
